module.exports = __webpack_public_path__ + "img/wa2.af407d81.png";